import { atom } from "recoil";

export const currentArticleIdState = atom({
  key: "enrollment/currentArticleId",
  default: "",
});
